enum ErrorCode {
  // 1***
  SERVER_ERROR = 1001,
  VALIDATION_ERRORS = 1002,
  UNAUTHORIZED_ERROR = 1003,
  USER_BANNED = 1004,
  GEO_RESTRICTED = 1005,
  USER_BLOCKED = 1006,
  // 2***
  INVALID_CREDENTIALS = 2001,
  USER_WITH_SPECIFIED_EMAIL_NOT_FOUND = 2002,
  CURRENCY_NOT_FOUND = 2005,
  EMAIL_ALREADY_REGISTER = 2006,
  DUPLICATE_CLICK_ID = 2012,
  DUPLICATE_GA_CLICK_ID = 2016,
  // 3***
  RECOVERY_USER_WITH_SPECIFIED_EMAIL_NOT_FOUND = 3002,
  RECOVERY_INVALID_CONFIRMATION_CODE = 3004,
  RECOVERY_INCORRECT_CONFIRMATION_CODE = 3005,

  // 6***
  INCORRECT_MAIL_DOMAIN = 6027,

  // 13***
  PROVIDER_ERROR = 13002,
  USER_SOCIAL_NETWORK_NOT_FOUND = 13003,
  DUPLICATE_USER_SOCIAL_NETWORK = 13004,
  SOCIAL_CURRENCY_NOT_FOUND = 13005,
  SOCIAL_CANNOT_REGISTER_WITH_THIS_CURRENCY = 13006,
  SOCIAL_TIMEZONE_NOT_FOUND = 13007,
  SOCIAL_LANGUAGE_NOT_FOUND = 13008,
  SOCIAL_DUPLICATE_CLICK_ID = 13009,
  SOCIAL_DUPLICATE_GA_CLICK_ID = 13010,
  SOCIAL_DUPLICATE_USER_EMAIL = 13011,
  SOCIAL_USER_NOT_FOUND = 13012,
  SOCIAL_NETWORK_CANNOT_BE_UNLINKED = 13014,
}

export default ErrorCode
